export default "__VITE_ASSET__DFE816mh__"